class PageCategory {
    constructor() {
        console.log('Home');

        const buttonReadMore = document.querySelector('.read-more-category');
        const blogContainer = document.querySelector('.blog-list .list');
        let offset = 4;
        let category = parseInt(buttonReadMore.dataset.category);

        buttonReadMore.addEventListener('click', () => {
            buttonReadMore.innerText = 'Carregando...';
            fetch(`${ajaxurl}?action=load_more_category&offset=${offset}&category=${category}`)
                .then((response) => {
                    response.json()
                        .then(data => {
                            data.forEach(post => {
                                let template = `
                                    <article class="card">
                                        <a href="${post.permalink}">
                                            <img src="${post.thumb}">
                                        </a>

                                        <div class="info">
                                            <a href="${post.categoryLink}" class="tag">${post.categoryName}</a>

                                            <h3 class="title"><a href="${post.permalink}">${post.postTitle}</a></h3>
                                            <p class="description"><a href="${post.permalink}">${post.postResume}</a></p>
                                        </div>
                                    </article>
                                `;

                                blogContainer.insertAdjacentHTML('beforeend', template);
                            });

                            buttonReadMore.innerText = data.length > 0 ? 'VER MAIS' : 'TODOS OS POSTS FORAM CARREGADOS';
                        })
                });

            offset += 4;
        });
    }
}

export default PageCategory;